export default {
  modalTitle: 'Qu’est ce que le mode de consultation?',
  modalText: 'Vous n\'avez pas la permission de modifier ou de mettre à jour les informations de cet utilisateur. Le mode "consultation" vous permez uniquement de simuler la vue d\'interface côté "client" pour voir les produits et services réservés pour cet utilisateur et vous n\'avez pas les droits de modifier ou de mettre à jour ces informations.',
  headerText: 'Mode consultation activé. ',
  modalLink: 'En savoir plus',
};
